import { useModal } from '@shared/model/useModal';

/**
 * Модалка предложения пакета (преподаватель -> ученик).
 * open({ chatId })
 */
export const usePackageOfferModal = () => useModal('package-offer');
